export const EnvNames = {
  Development: "development",
  Test: "test",
  Staging: "staging",
  Production: "production",
};

export const SystemType = {
  Jiemo: "jiemo",
  RSS: "rss",
  VSS: "vss",
  LPS: "lps",
};
